export function redirect(path) {
  window.open(path, "_blank");
}

export function getCopyRight() {
  const thisYear = new Date().getFullYear();
  return `©2024 - ${thisYear} The Xu Lab. All Rights Reserved.`;
}